import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});

export async function getAllCertifications(query:string, perPage:number, pageNo:number) {
    try {
        const response = await authService.apiCall(`${BASE_URL}/certificates?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
            method: 'GET',
           
        });

        if (!response.ok) {
            throw new Error('Failed to fetch certifications');
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error fetching certifications:', error);
        throw new Error('Error fetching certifications');
    }
}
